import React, { FC, ReactNode } from 'react'
import styled from 'styled-components'
import { Fonts, Button } from 'components/base-ui'

interface EmptyItemPageProps {
  imagePath?: string
  srcSet?: string
  title: string
  buttonTitle
  onClickButton: () => void
  children?: ReactNode
}

const EmptyStatePage: FC<EmptyItemPageProps> = ({ imagePath, srcSet, title, buttonTitle, onClickButton, children }) => {
  return (
    <Wrapper>
      <EmptyCover>
        {imagePath && <img alt={title} src={imagePath} srcSet={srcSet} />}
        {children}
      </EmptyCover>
      <EmptyWordingWrapper data-testid="empty-state-title">{title}</EmptyWordingWrapper>
      <ButtonWrapper>
        <Button minWidth="175px" md2 enableFastClick={false} onClick={onClickButton}>
          {buttonTitle}
        </Button>
      </ButtonWrapper>
    </Wrapper>
  )
}

export default EmptyStatePage
const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`
const EmptyCover = styled.div`
  margin-bottom: 30px;
  text-align: center;
`

const EmptyWordingWrapper = styled(Fonts.H2)`
  margin: 0 auto;
  margin-bottom: 25px;
  text-align: center;
  color: black;
`

const ButtonWrapper = styled.div`
  text-align: center;
`
